import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import ProfilePageHeader from "components/ProfilePageHeader";
import {SettingLinksN as SettingLinks} from "components/settings/SettingLinks";
import { useParams } from "react-router-dom";
import { useCustomHistory, useWindowLocation } from "hooks";
import * as ROUTE_CONSTANTS from "routes/constants";
import { Logout } from "store/actions";
import WithLoading from "components/Hoc/WithLoading";
import C from "Constants";
import EditUserProfile from "pages/profile/EditUserProfile";
import { PageHeaderV2 } from "components/PageHeader";

//TODO: requires cleanup

const Setting = () => {

  const dispatch = useDispatch();
  const params = useParams();
  const router = useCustomHistory();
  const windowRouter = useWindowLocation();

  const [isEditProfile, setIsEditProfile] = useState(false);
  const { brandInfo } = useSelector((state) => state?.brandStorageReducer);
  // const [settings, setSettings] = useState();
  const { selectedStore, outletBasedSelectedStoreArea } = useSelector(
    (state) => state.store
  );
  const { DomainType, orderType } = useSelector((state) => state.AppReducer);
  // const { brandInfo: Brand } = useSelector(
  //   (state) => state?.brandStorageReducer
  // );
  const isMounted = useRef(false);
  // useEffect(() => {
  //   const getBrand = async () => {
  //     if (Brand) {
  //       const { setting } = Brand;
  //       setSettings(setting);
  //     }
  //   };
  //   getBrand();
  // }, []);

  const homePageUrl = ROUTE_CONSTANTS.HOME[1];
  const storePageUrl = ROUTE_CONSTANTS.OUTLET_STORE[1];

  const gotoStorePage = () =>
    router(storePageUrl, `/${params?.domainName}${storePageUrl}`, DomainType);

  const goBack = () => {
    if (
      orderType?.serviceType === C.SERVICE_TYPE.DELIVERY &&
      selectedStore &&
      outletBasedSelectedStoreArea
    )
      gotoStorePage();
    else if (orderType?.serviceType === C.SERVICE_TYPE.PICKUP && selectedStore)
      gotoStorePage();
    else router("/", `/${params?.domainName}${homePageUrl}`, DomainType);
  };

  const logout = () => {
    localStorage.setItem("logoutEvent", Date.now().toString());
    localStorage.removeItem(brandInfo?.brand?._id);
    // window.sessionStorage.clear();
    dispatch(Logout.logout());
    windowRouter("/", `/${params?.domainName}`, DomainType);
  };

  const showMyOrders = () => {
    let url = ROUTE_CONSTANTS.ECOMMERCE_MY_ORDERS[1];
    if (params) {
      router(url, `/${params?.domainName}${url}`, DomainType);
    }
  };

   //TODO: Edit Profile route is not working, need to fix it
   const handleEditProfile = () => {
    setIsEditProfile(true);
    // router(
    //   `/dine-in/auth/edit-profile?${queryParam}`,
    //   `/${params.domainName}/dine-in/auth/edit-profile?${queryParam}`,
    //   DomainType
    // );
  };

  useEffect(() => {
    const element = document.querySelector(".system-container");
    if (element && isMounted.current) {
      // Store the original height
      const originalHeight = element.style.getPropertyValue("height");
  
      // Set our custom height with !important
      if(isEditProfile){
        element.style.setProperty("height", originalHeight, "important");
      }else{
        element.style.setProperty("height", "auto", "important");
      }
  
      // Cleanup: restore original on unmount
      return () => {
        if (originalHeight) {
          element.style.setProperty("height", originalHeight, "important");
        } else {
          element.style.removeProperty("height");
        }
      };
    }
  }, [isMounted, isEditProfile]);

  return (
    <WithLoading>
        {params && (
          <div ref={isMounted}>
              <PageHeaderV2
          containerStyleProps={{
            style: {
              zIndex: 100,
              position: "relative",
            },
          }}
          headerStyleProps={{
            className: "p-6",
          }}
          pageTitle={isEditProfile ? "Edit Profile" : "User Settings"}
          onGoBack={isEditProfile ? ()=>setIsEditProfile(false) :()=>goBack()}
          hideAuth={true}
        />
           {isEditProfile ? 
            <EditUserProfile setUserInfoModal={()=>setIsEditProfile(false)} isOpenUserInfoModal={isEditProfile}/>
            :
            <div className="p-6 mt-3">
            <SettingLinks
              handleAllOrders={showMyOrders}
              handleLogout={logout}
              handleEditProfile={handleEditProfile}
            />
            </div>
           }
          </div>
        )}
    </WithLoading>
  );
};

export default Setting;
